// extracted by mini-css-extract-plugin
export default {"container":"UserChipCellRenderer_container__z8nDz","avatar":"UserChipCellRenderer_avatar__Cpnfm"};